import React, { useRef, useState } from "react";
import Swal from "sweetalert2";

import { getProductosByDescripcion } from "../repository";

const  SearchByDesc = ({actualizarproductos}) => {
  const descRef = useRef("");
  const [desc, setDesc] = useState("");
  const [loading, setLoading] = useState(0);
  const [, setProductos] = useState([]);
  const [, setStatus] = useState(null);
  const [hasError, setHasError] = useState(false);

  // Toast configuration
  const Toast = Swal.mixin({
    toast: true,
    position: "top",
    showConfirmButton: false,
    timer: 2500,
    timerProgressBar: true,
  });

  const changeState = () => {
      setDesc(descRef.current.value);
      setHasError(false);
      setProductos([]);
      setStatus(null);
      actualizarproductos([]);
  };

  //Search Products
  const search = (e) => {
    e.preventDefault();
    setProductos([]);
    setStatus(null);

    // Validación simple: campo no vacío
    if (!desc || desc.trim() === "") {
      setHasError(true);
      Toast.fire({
        icon: "warning",
        text: "Ingresa un término de búsqueda",
      });
      return;
    }

    setLoading(1);
    setHasError(false);
    getProductosByDescripcion(desc)
        .then((response) => {          
         
          if (response.status === "success") {
            setStatus("success");
            setProductos(response.result);
            actualizarproductos(response.result);
            setLoading(0);
            if(response.result.length === 0) {
              Swal.fire({
                title: '<span style="font-size: 20px; font-weight: 600;">Búsqueda incompleta</span>',
                html: `
                  <p style="font-size: 14px; margin-bottom: 12px;">Agrega más detalles a tu búsqueda para obtener mejores resultados.</p>
                  <p style="font-size: 14px; margin-bottom: 8px;"><strong>Ejemplos:</strong></p>
                  <p style="font-size: 14px; margin: 3px 0;">• "amortiguador tsuru"</p>
                  <p style="font-size: 14px; margin: 3px 0;">• "rotula civic"</p>
                  <p style="font-size: 14px; margin: 3px 0;">• "tacoma 2020"</p>
                `,
                showCloseButton: false,
                confirmButtonText: "Entendido",
                confirmButtonColor: "#f7a209",
                width: "340px",
                padding: "1.5em",
              });
            }
          } else {
            setLoading(0);
            Swal.fire({
              title: '<span style="font-size: 20px; font-weight: 600;">Búsqueda incompleta</span>',
              html: `
                <p style="font-size: 14px; margin-bottom: 12px;">Agrega más detalles a tu búsqueda para obtener mejores resultados.</p>
                <p style="font-size: 14px; margin-bottom: 8px;"><strong>Ejemplos:</strong></p>
                <p style="font-size: 14px; margin: 3px 0;">• "amortiguador tsuru"</p>
                <p style="font-size: 14px; margin: 3px 0;">• "rotula civic"</p>
                <p style="font-size: 14px; margin: 3px 0;">• "tacoma 2020"</p>
              `,
              showCloseButton: false,
              confirmButtonText: "Entendido",
              confirmButtonColor: "#f7a209",
              width: "340px",
              padding: "1.5em",
            });
          }
        })
        .catch((err) => {
          setLoading(0);
          Swal.fire({
            text: "Error al obtener la información.",
            icon: "error",
            confirmButtonColor: "#f7a209",
          });
        });
  };

    return (
      <div>
        {/* CONTENT */}
        <section id="searchContent" className="mt-1">
          <form onSubmit={search}>
            <div className="container">
              <div className="row align-items-center justify-content-center">
                <div className="col-12 col-sm-auto mb-2 mb-sm-0">
                  <h6 className="mb-0">Descripción:</h6>
                </div>
                <div className="col-12 col-sm-6 col-md-4 mb-2">
                  <input
                    name="txtDesc"
                    type="text"
                    className="form-control"
                    style={hasError ? {
                      borderColor: "#dc3545",
                      boxShadow: "0 0 0 0.2rem rgba(220, 53, 69, 0.25)",
                      animation: "shake 0.5s"
                    } : {}}
                    defaultValue=""
                    ref={descRef}
                    autoComplete="off"
                    placeholder="Ej: tsuru, aveo 2018, rotula civic 2012"
                    onChange={changeState}
                    maxLength="50"
                  />
                </div>
                <div className="col-12 col-sm-auto mb-2 mt-3 mt-sm-0">
                  <button className="btn btn-secondary w-100" type="submit">
                    <i className="fa fa-search mr-1"></i>Buscar
                  </button>
                </div>
              </div>

              {loading === 1 && (
                <div className="text-center mb-3 mt-3">
                  <h6>Buscando...</h6>
                  <div
                    className="spinner-border text-warning"
                    role="status"
                    aria-hidden="true"
                  ></div>
                </div>
              )}
                    {/*
              {status === "success" && (
                <Fragment>
                  <div className="row mt-3">
                    <div className="col-md-3"></div>
                    <div className="col-md-6 text-center">
                      <h6>
                        <span className="badge badge-warning ml-1 mr-1">
                          {productos.length}
                        </span>
                        <small>
                          <strong>Producto(s) encontrado(s)</strong>
                        </small>
                      </h6>
                      <div className="col-md-3"></div>
                    </div>
                  </div>
                  <div className="row">
                    {productos.map((item, index) => (
                      <ProductItem
                        item={item}
                        index={index}
                        add={prop.addToCart}
                        key = {index}
                      />
                    ))}
                  </div>
                </Fragment>
              )}

                */}
            </div>
          </form>
        </section>
      </div>
    );
  }
export default SearchByDesc;
